import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import './Comecando.css';

function Comecando() {
    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Começando</h1>
                        <p className="mb-0 text-gray">Tutorial completo para começar a usar o EasyCripto</p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12">
                        <div className="card border-0 shadow-sm mb-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                            <div className="card-body text-white p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <svg className="icon icon-lg me-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                    <h2 className="h5 mb-0">Bem-vindo ao EasyCripto!</h2>
                                </div>
                                <p className="mb-0">Este tutorial irá guiá-lo através dos passos necessários para configurar sua conta e começar a usar todas as funcionalidades do software de trading automatizado.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #f59e0b' }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" style={{ width: '56px', height: '56px', backgroundColor: '#f59e0b', color: '#ffffff' }}>
                                        <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>1</span>
                                    </div>
                                    <div>
                                        <h3 className="h5 mb-0">Passo 1</h3>
                                        <p className="text-muted mb-0 small">Criar conta na Binance</p>
                                    </div>
                                </div>
                                <p className="mb-3">Para começar a usar o EasyCripto, você precisa ter uma conta na Binance, uma das maiores exchanges de criptomoedas do mundo.</p>
                                <div className="mb-3">
                                    <h5 className="h6 mb-2">Como criar sua conta:</h5>
                                    <ol className="ps-3">
                                        <li className="mb-2">Acesse o site oficial da Binance</li>
                                        <li className="mb-2">Clique em "Registrar" ou "Criar Conta"</li>
                                        <li className="mb-2">Preencha seus dados pessoais</li>
                                        <li className="mb-2">Verifique seu e-mail</li>
                                        <li className="mb-2">Complete a verificação de identidade (KYC)</li>
                                    </ol>
                                </div>
                                <a 
                                    href="https://www.binance.com/pt-BR/register" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-warning w-100"
                                >
                                    Criar Conta na Binance
                                    <svg className="icon icon-xs ms-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                                        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #10b981' }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" style={{ width: '56px', height: '56px', backgroundColor: '#10b981', color: '#ffffff' }}>
                                        <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>2</span>
                                    </div>
                                    <div>
                                        <h3 className="h5 mb-0">Passo 2</h3>
                                        <p className="text-muted mb-0 small">Criar Chaves de API</p>
                                    </div>
                                </div>
                                <p className="mb-3">As chaves de API servem para executar operações de trading.</p>
                                <div className="mb-3">
                                    <h5 className="h6 mb-2">Como criar suas chaves:</h5>
                                    <ol className="ps-3">
                                        <li className="mb-2">Faça login na sua conta Binance</li>
                                        <li className="mb-2">Acesse o menu do perfil e vá em "API Management"</li>
                                        <li className="mb-2">Clique em "Create API"</li>
                                        <li className="mb-2">Escolha "System generated" e complete a verificação de segurança</li>
                                        <li className="mb-2">Configure as permissões necessárias (leitura e trading)</li>
                                        <li className="mb-2">Copie a API Key e Secret Key (guarde em local seguro!)</li>
                                    </ol>
                                </div>
                                <div className="alert alert-info mb-3">
                                    <small>
                                        <strong>Importante:</strong> Nunca compartilhe suas chaves de API com ninguém. 
                                        A Secret Key só é mostrada uma vez - guarde-a com segurança!
                                    </small>
                                </div>
                                <a 
                                    href="https://www.binance.com/pt-BR/my/settings/api-management" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-success w-100"
                                >
                                    Gerenciar API Keys
                                    <svg className="icon icon-xs ms-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                                        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #3b82f6' }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" style={{ width: '56px', height: '56px', backgroundColor: '#3b82f6', color: '#ffffff' }}>
                                        <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>3</span>
                                    </div>
                                    <div>
                                        <h3 className="h5 mb-0">Passo 3</h3>
                                        <p className="text-muted mb-0 small">Configurar no EasyCripto</p>
                                    </div>
                                </div>
                                <p className="mb-3">Após criar suas chaves de API na Binance, você precisa configurá-las no EasyCripto para começar a usar o software.</p>
                                <div className="mb-3">
                                    <h5 className="h6 mb-2">O que fazer:</h5>
                                    <ol className="ps-3">
                                        <li className="mb-2">Acesse a página de Configurações no menu lateral</li>
                                        <li className="mb-2">Na seção "Configurações Binance", cole sua API Key Spot</li>
                                        <li className="mb-2">Cole sua Secret Key Spot</li>
                                        <li className="mb-2">Se tiver acesso a Futures, configure também as chaves Futures</li>
                                        <li className="mb-2">Clique em "Salvar" para confirmar</li>
                                    </ol>
                                </div>
                                <div className="mb-3">
                                    <h5 className="h6 mb-2">Configurar Email e Telegram:</h5>
                                    <ul className="ps-3">
                                        <li className="mb-2">Ainda em Configurações, vá até a seção de notificações</li>
                                        <li className="mb-2">Informe o email de recebimento dos alertas</li>
                                        <li className="mb-2">Se quiser alertas no Telegram, informe apenas o ID</li>
                                        <li className="mb-2">Salve para ativar os avisos de operações e eventos</li>
                                    </ul>
                                </div>
                                <a 
                                    href="/settings" 
                                    className="btn btn-primary w-100"
                                >
                                    Ir para Configurações
                                    <svg className="icon icon-xs ms-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 mb-4">
                        <div className="card border-0 shadow-sm h-100" style={{ borderTop: '4px solid #8b5cf6' }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#8b5cf6', width: '56px', height: '56px', color: '#ffffff' }}>
                                        <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>4</span>
                                    </div>
                                    <div>
                                        <h3 className="h5 mb-0">Passo 4</h3>
                                        <p className="text-muted mb-0 small">Explorar Funcionalidades</p>
                                    </div>
                                </div>
                                <p className="mb-3">Agora que está tudo configurado, você pode explorar todas as funcionalidades do EasyCripto!</p>
                                <div className="mb-3">
                                    <h5 className="h6 mb-2">Principais recursos:</h5>
                                    <ul className="ps-3">
                                        <li className="mb-2"><strong>Dashboard:</strong> Visualize gráficos e estatísticas em tempo real</li>
                                        <li className="mb-2"><strong>Estratégias:</strong> Crie e gerencie suas estratégias de trading</li>
                                        <li className="mb-2"><strong>Automações:</strong> Configure bots para operar automaticamente</li>
                                        <li className="mb-2"><strong>Agente IA:</strong> Use inteligência artificial para sugestões</li>
                                        <li className="mb-2"><strong>Relatórios:</strong> Acompanhe o desempenho das suas operações</li>
                                    </ul>
                                </div>
                                <a 
                                    href="/funcionalidades" 
                                    className="btn btn-purple w-100"
                                    style={{ backgroundColor: '#8b5cf6', borderColor: '#8b5cf6', color: 'white' }}
                                >
                                    Ver Funcionalidades
                                    <svg className="icon icon-xs ms-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12">
                        <div className="card border-0 shadow-sm" style={{ borderTop: '4px solid #ef4444' }}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="bg-danger bg-opacity-10 rounded-circle p-3 me-3">
                                        <svg className="icon icon-lg text-danger" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="h5 mb-0">Dicas de Segurança</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <h6 className="fw-bold mb-2">Proteja suas chaves de API</h6>
                                        <ul className="small ps-3 mb-0">
                                            <li>Nunca compartilhe suas chaves com terceiros</li>
                                            <li>Use apenas permissões necessárias (não habilite saques)</li>
                                            <li>Configure restrições de IP se possível</li>
                                            <li>Revise periodicamente suas chaves ativas</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <h6 className="fw-bold mb-2">Boas práticas</h6>
                                        <ul className="small ps-3 mb-0">
                                            <li>Comece com valores pequenos para testar</li>
                                            <li>Monitore suas automações regularmente</li>
                                            <li>Use stop-loss para limitar perdas</li>
                                            <li>Mantenha backups das suas configurações</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </main>
        </>
    );
}

export default Comecando;

